import { CritereRecherche } from '../../configuration/shared/classes/critere-recherche';
import { ETypeChamp } from '../../z16pro/classes/typeChamp';

export interface ISearchFilter {
    key: string;
    compare?: string;
    value?: any;
    critere?: CritereRecherche;
    action?: boolean;
    event?: boolean;
    type?: string;
    isZ16Pro?: boolean;
}

export class SearchFilter {

    key: string;
    compare?: string;
    value?: any;
    critere?: CritereRecherche;
    action?: boolean;
    event?: boolean;
    type?: string;
    isZ16Pro?: boolean;

    constructor(filter: ISearchFilter) {
        this.key = filter.key;
        this.value = filter.value;
        this.compare = filter.compare;
        this.critere = filter.critere;
        this.action = filter.action;
        this.event = filter.event;
        this.type = filter.type;
        this.isZ16Pro = filter.isZ16Pro;
    }

    shouldAddInfixWildcard(): boolean {
        return this.compare === 'LIKE';
    }

    isValueEmpty(): boolean {
        const { value } = this;

        switch (this.type) {
            case ETypeChamp.CHECKBOX:
                return value == null || value === '0' || value === '';
            case ETypeChamp.TEXT:
            case ETypeChamp.TEXTAREA:
            case ETypeChamp.SELECT:
            case ETypeChamp.RADIO:
            default:
                return value == null || value === '' || value === [];
        }
    }

}
